import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import { buttonClass } from './ui/Button';

// The machine details panel's rename affordance (#6566): a pencil beside the heading,
// offered only on a row that may be renamed — a member's row has none (owner ruling G21).
// It only toggles the ONE rename form in the panel body; the form, the rename write and
// the opener's rename target stay `MachinePanel`'s to coordinate.

export function MachinePanelRenamePencil(props: {
  /** The machine's display name, in the accessible label. */
  readonly name: string;
  /** Whether the row may be renamed at all (`canRenameMachine`). */
  readonly offered: boolean;
  /** Whether the form is open, for `aria-expanded`. */
  readonly expanded: boolean;
  readonly onToggle: () => void;
}): JSX.Element {
  return (
    <Show when={props.offered}>
      <button
        type="button"
        class={`${buttonClass({ variant: 'ghost', size: 'icon-sm' })} machine-panel__rename`}
        aria-label={t('fleet.panel.rename_named', { name: props.name })}
        aria-expanded={props.expanded}
        onClick={props.onToggle}
      >
        <span aria-hidden="true">✎</span>
      </button>
    </Show>
  );
}
